import { render } from "./LinkTitle.vue?vue&type=template&id=943992e2&scoped=true"
import script from "./LinkTitle.vue?vue&type=script&lang=js"
export * from "./LinkTitle.vue?vue&type=script&lang=js"

import "./LinkTitle.vue?vue&type=style&index=0&id=943992e2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-943992e2"]])

export default __exports__